import { render, staticRenderFns } from "./PavilionList.vue?vue&type=template&id=959ad430&scoped=true&"
import script from "./PavilionList.vue?vue&type=script&lang=js&"
export * from "./PavilionList.vue?vue&type=script&lang=js&"
import style0 from "./PavilionList.vue?vue&type=style&index=0&id=959ad430&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959ad430",
  null
  
)

export default component.exports